export default __webpack_public_path__ + "3ad82d6b23664689d4e8f8d613140f0c.svg";